'use strict';

import AppDispatcher from '../AppDispatcher';
import { createStore, mergeIntoBag } from '../utils/StoreUtils';

const _sections = {};

const SectionStore = createStore({
  get(id) {
    return _sections[id];
  }
});

SectionStore._objects = _sections;

SectionStore.dispatchToken = AppDispatcher.register(function (payload) {
  const action = payload.action;
  const response = action.response;
  const entities = response && response.entities;
  const sections = entities && entities.sections;

  if (sections) {
    mergeIntoBag(_sections, sections);
    SectionStore.emitChange();
  }
});

export default SectionStore;


/** WEBPACK FOOTER **
 ** ./stores/SectionStore.js
 **/